import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { navbarActions } from "../store/navbar";

export const useCollapseNavbar = () => {
  const dispatch = useDispatch();
  const collapsed = useSelector((state: any) => state.navbar.collapsed);
  const hoverExpanded = useSelector((state: any) => state.navbar.hoverExpanded);

  const toggleCollapse = useCallback(() => {
    const newCollapsed = !collapsed;
    dispatch(navbarActions.setCollapsed(newCollapsed));
    if (!newCollapsed) dispatch(navbarActions.setHoverExpanded(false));
  }, [collapsed, dispatch]);

  const handleMouseEnter = useCallback(() => {
    if (collapsed) {
      dispatch(navbarActions.setHoverExpanded(true));
    }
  }, [collapsed]);

  const handleMouseLeave = useCallback(() => {
    if (collapsed) {
      dispatch(navbarActions.setHoverExpanded(false));
    }
  }, [collapsed]);

  return {
    collapsed,
    hoverExpanded,
    toggleCollapse,
    handleMouseEnter,
    handleMouseLeave,
  };
};